module.exports = __webpack_public_path__ + "img/pizzaset-773.ae1fb248.png";